import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://tvremote.myportfoliodata.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [, key, name] = selector.match(/meta\[(.+?)="(.+?)"\]/) || [];
    if (key && name) el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const SEO = ({ title, description, image, type = 'website' }) => {
  const { pathname } = useLocation();
  const url = `${SITE_URL}${pathname}`;
  const img = image || DEFAULT_IMAGE;

  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta('meta[name="description"]', 'content', description);

    setMeta('meta[property="og:title"]', 'content', title || '');
    setMeta('meta[property="og:description"]', 'content', description || '');
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('meta[property="og:type"]', 'content', type);
    setMeta('meta[property="og:image"]', 'content', img);

    setMeta('meta[name="twitter:title"]', 'content', title || '');
    setMeta('meta[name="twitter:description"]', 'content', description || '');
    setMeta('meta[name="twitter:image"]', 'content', img);

    setLink('canonical', url);
  }, [title, description, img, url, type]);

  return null;
};

export default SEO;
